import { z } from 'zod'

// Laravel `email` accepts what the HTML5 input[type=email] grammar accepts, so `a@b` passes
export const email = (maxLength: number): z.ZodEmail =>
  z.email({ pattern: z.regexes.html5Email }).max(maxLength)
